import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import Regular from "./Rajdhani-Regular.woff2";

export const RajdhaniRegularFontFaces: ExcalidrawFontFaceDescriptor[] = [
  { uri: Regular },
];
